<template>
  <div class="article-card">
    <div class="tags">
      <div class="tag on" v-if="content.status === 1">
        <span>已发布</span>
      </div>
      <div class="tag off" v-if="content.status === 0">
        <span>未发布</span>
      </div>
    </div>
    <img :src="content.picture_url" />
    <div class="content-text-wrap">
      <p class="title">{{content.title}}</p>
      <div class="item-footer">
        <span class="author">{{content.author ? content.author.nickname : ''}}</span>
        <span class="hot">{{content.pv}}</span>
      </div>
    </div>
    <div class="menu">
      <div class="menu-item">
        <router-link :to="`/article/edit/${content.id}`">
          <i class="el-icon-edit"></i>
          <span>编辑</span>
        </router-link>
      </div>
      <div class="divider"></div>
      <div class="menu-item" @click="handleToPreview">
        <i class="el-icon-zoom-in"></i>
        <span>浏览</span>
      </div>
      <div class="divider"></div>
      <div class="menu-item" @click="handelArticleRemove">
        <i class="el-icon-delete"></i>
        <span>删除</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "article-card",
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    // 预览
    handleToPreview() {
     if (this.content) {
        if (location.host.includes('admin.kaoyanbox.com')) {
          window.open(`https://h5.kaoyanbox.com/article/detail/${this.content.id}`)
        } else {
          window.open(`http://h5.kaoyanbox.net/article/detail/${this.content.id}`)
        }
      }
    },
    handelArticleRemove() {
      this.$emit("remove", this.content.id);
    },
  },
};
</script>

<style lang="less" scoped>
.article-card {
  position: relative;
  width: 260px;
  color: #303133;
  background-color: #fff;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  overflow: hidden;

  .tags {
    position: absolute;
    left: 0;
    top: 0;
    display: flex;

    .tag {
      background: #ff6600;
      border-radius: 4px;
      border-top-right-radius: 0px;
      border-bottom-left-radius: 0px;
      font-size: 12px;
      color: #fff;
      padding: 3px 10px;

      &:not(:first-child) {
        margin-left: 5px;
      }
      &.on {
        background: #409EFF;
      }
    }
  }

  img {
    width: 100%;
    height: 136px;
    object-fit: cover;
  }
  .content-text-wrap {
    display: flex;
    flex-direction: column;
    height: 82px;
    padding: 10px;
  }
  .title {
    flex: 1;
    font-size: 16px;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .item-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
  }
  a {
    text-decoration: none;
  }

  .menu {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f2f2f2;

    .menu-item {
      display: flex;
      justify-content: center;
      cursor: pointer;
      padding: 10px 20px;

      i {
        margin-right: 2px;
      }
    }
    .divider {
      height: 20px;
      border-right: 1px solid #ccc;
    }
  }
}
</style>
